<template>
  <div>
    <div class="row mt-2 mb-2"></div>
    <p class="bb-hdg mt-2 mb-3">Specialist Details</p>
    <div class="row mt-2 mb-2">
      <div class="col form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-left"
            :value="activeItem.effect"
            id="effect"
            disabled
          />
          <label
            class="bb-float-label optional"
            for="effect"
            >Effect</label
          >
        </div>
      </div>
      <div class="col form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-left"
            :value="activeItem.delay"
            id="delay"
            disabled
          />
          <label
            class="bb-float-label optional"
            for="delay"
            >Delay</label
          >
        </div>
      </div>
    </div>

    <div class="row mt-2 mb-2">
      <div class="col form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-left"
            :value="activeItem.damage_dice"
            id="damage_dice"
            disabled
          />
          <label
            class="bb-float-label optional"
            for="damage_dice"
            >Damage Dice</label
          >
        </div>
      </div>
      <div class="col form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-left"
            :value="activeItem.duration"
            id="duration"
            disabled
          />
          <label
            class="bb-float-label optional"
            for="duration"
            >Duration</label
          >
        </div>
      </div>
    </div>

    <div class="row mt-2 mb-2">
      <div class="col-6 form-group">
        <div class="form-floating">
          <input
            readonly
            class="form-control text-left"
            :value="activeItem.resist"
            id="resist"
            disabled
          />
          <label
            class="bb-float-label optional"
            for="resist"
            >Resist</label
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemSpecialistTab',
  props: {
    activeItem: {
      type: Object,
      required: true,
    },
    localItem: {
      type: Object,
      default: () => ({}),
    },
    onCounterChanged: {
      type: Function,
      default: () => {},
    },
    showCurUnitCount: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
